import { timezoneCountryCodeMap } from "../constants";

export default function getCountryCodeByTimeZone() {
  return timezoneCountryCodeMap[Intl.DateTimeFormat().resolvedOptions().timeZone];
}
